// Evita pantalla blanca cuando el traductor del navegador (Chrome Android) altera el DOM que maneja React.
if (typeof Node === "function" && Node.prototype) {
  const removeChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      if (child.parentNode) return child.parentNode.removeChild(child);
      return child;
    }
    return removeChild.apply(this, arguments);
  };
  const insertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      return referenceNode.parentNode
        ? insertBefore.call(referenceNode.parentNode, newNode, referenceNode)
        : this.appendChild(newNode);
    }
    return insertBefore.apply(this, arguments);
  };
}
